import { Content } from "antd/es/layout/layout";
import { Typography } from "antd";
import { useLoaderData } from "react-router-dom";
import { ContactManagementPageLoaderType } from "./loaders";
import { FormattedHoursTag } from "~/components/DateAndTime";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const { Title, Text, Paragraph } = Typography;

const ContactManagementPage = () => {
  const loaderData = useLoaderData() as ContactManagementPageLoaderType;
  const { t } = useAppTranslation();

  return (
    <Content className="contact-management-info">
      {loaderData.propertyManager !== null ? (
        <>
          <Title className="contact-management-title" level={1}>
            {t("Contact_Management")}
          </Title>
          <Paragraph className="contact-management-item">
            <Text strong>{t("Company_Name")}:</Text>{" "}
            {loaderData.propertyManager?.companyName}
          </Paragraph>
          <Paragraph className="contact-management-item">
            <Text strong>{t("Phone_Number")}:</Text>{" "}
            <a
              href={`tel:+${loaderData.propertyManager?.phoneNumber?.replaceAll(
                "-",
                ""
              )}}`}
            >
              {loaderData.propertyManager?.phoneNumber}
            </a>
          </Paragraph>
          <Paragraph className="contact-management-item">
            <Text strong>{t("Email_Address")}:</Text>{" "}
            <a href={`mailto:${loaderData.propertyManager?.email}}`}>
              {loaderData.propertyManager?.email}
            </a>
          </Paragraph>
          <Paragraph className="contact-management-item">
            <Text strong>{t("Office_Address")}:</Text>{" "}
            {loaderData.propertyManager?.officeAddress}
          </Paragraph>
          <Paragraph className="contact-management-item">
            <Text strong>{t("Working_Hours")}:</Text>
            <br />
            {loaderData.propertyManager?.workingHours
              ? FormattedHoursTag(loaderData.propertyManager.workingHours)
              : ""}
          </Paragraph>
        </>
      ) : (
        <></>
      )}

      {/* Contact Us Form */}
      <Title className="contact-management-title" level={1}>
        {t("Contact_Bomani")}
      </Title>
      <Paragraph className="contact-management-item">
        <Text strong>{t("Phone_Number")}:</Text>{" "}
        <a
          href={`tel:+${loaderData.bomaniTeamInfo?.phoneNumber?.replaceAll(
            "-",
            ""
          )}}`}
        >
          {loaderData.bomaniTeamInfo?.phoneNumber}
        </a>
      </Paragraph>
      <Paragraph className="contact-management-item">
        <Text strong>{t("Email_Address")}:</Text>{" "}
        <a href={`mailto:${loaderData.bomaniTeamInfo?.email}}`}>
          {loaderData.bomaniTeamInfo?.email}
        </a>
      </Paragraph>
      <Paragraph className="contact-management-item">
        <Text strong>{t("Working_Hours")}:</Text>
        <br />
        {loaderData.bomaniTeamInfo?.workingHours
          ? FormattedHoursTag(loaderData.bomaniTeamInfo.workingHours)
          : ""}
      </Paragraph>
    </Content>
  );
};

export default ContactManagementPage;
